import React from 'react';
import { NavLink } from 'react-router-dom';
import { useAuth } from '../../hooks/useAuth';

const Navbar = () => {
  const { user, logout } = useAuth();

  const menuItems = [
    { path: '/pos', label: 'POS', icon: '💳' },
    { path: '/orders', label: 'Orders', icon: '📦' },
    { path: '/customers', label: 'Customers', icon: '👥' },
    { path: '/subscriptions', label: 'Subscriptions', icon: '🏷️' },
    { path: '/services', label: 'Services', icon: '🧺' },
    { path: '/payments', label: 'Payments', icon: '💰' },
    // Roles & Permissions — only visible to admin
    ...(user?.role === 'admin'
      ? [{ path: '/roles', label: 'Roles', icon: '🔐' }]
      : [])
  ];

  return (
    <nav className="navbar">
      <div className="navbar-left">
        <h1 className="navbar-brand">CashUCoin</h1>
      </div>

      <div className="navbar-center">
        {menuItems.map((item) => (
          <NavLink
            key={item.path}
            to={item.path}
            className={({ isActive }) =>
              `navbar-link ${isActive ? 'active' : ''}`
            }
          >
            <span className="navbar-icon">{item.icon}</span>
            <span className="navbar-label">{item.label}</span>
          </NavLink>
        ))}
      </div>
      
      <div className="navbar-right">
        <div className="user-info">
          <span className="user-name">{user?.name}</span>
          <span className="user-role">{user?.role}</span>
        </div>
        <button onClick={logout} className="btn btn-secondary btn-small">
          Logout
        </button>
      </div>
    </nav>
  );
};

export default Navbar;
